<template>
  <li :class="['relative', !last && 'md:pb-20 md:pr-0 w-1/3 md:w-full flex-grow']">
    <div class="hidden md:block">
      <div
        v-if="!last"
        :class="['-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full', completed ? 'bg-fuchsia' : 'bg-gray-medium']"
      />
      <div class="relative flex space-x-4">
        <div class="h-9 flex items-center">
          <template v-if="completed">
            <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-fuchsia rounded-full">
              <!-- Heroicon name: check -->
              <svg class="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            </span>
          </template>
          <template v-else-if="active">
            <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-fuchsia rounded-full">
              <span class="text-fuchsia">{{ number }}</span>
            </span>
          </template>
          <template v-else>
            <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-medium rounded-full">
              <span class="text-gray-medium">{{ number }}</span>
            </span>
          </template>
        </div>

        <div class="min-w-0 ml-4 flex items-center font-sans-medium text-lg">
          <div :class="['leading-4 ', active ? 'text-fuchsia' : 'text-gray-medium']">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <div class="block md:hidden">
      <div class="absolute inset-0 flex items-center">
        <div :class="['h-0.5 w-full', completed ? 'bg-fuchsia' : 'bg-gray-medium']" />
      </div>
      <div class="relative w-8 h-8 flex items-center justify-center bg-fuchsia rounded-full">
        <template v-if="completed">
          <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-fuchsia rounded-full">
              <!-- Heroicon name: check -->
              <svg class="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            </span>
        </template>
        <template v-else-if="active">
          <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-fuchsia rounded-full">
            <span class="text-fuchsia">{{ number }}</span>
          </span>
        </template>
        <template v-else>
          <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-medium rounded-full group-hover:border-gray-400 group-focus:border-gray-400 transition ease-in-out duration-150">
            <span class="text-gray-medium">{{ number }}</span>
          </span>
        </template>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "RegisterStepListItem",
  props: {
    last: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false,
    },
    completed: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Number,
      required: true,
    }
  },
}
</script>

<style scoped>
.top-4 {
  top: 1rem;
}
.left-4 {
  left: 1rem;
}
.mt-0\.5 {
  margin-top: .125rem;
}
.w-0\.5 {
  width: .125rem;
}
.bg-gray-lighter {
  background-color: #d2d6dc;
}
.h-2\.5 {
  height: .625rem;
}
.w-2\.5 {
  width: .625rem;
}

.inset-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.h-0\.5 {
  height: .125rem;
}
</style>